/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export interface UpsertPermissionDto {
  featureSetIds?: string[];
  roleIds?: string[];
  allowed?: string[];
  denied?: string[];
}

export interface FeatureSetRoleItem {
  id?: string;
  name?: string;
}

export interface FeatureSetRolesListDto {
  featureSets?: FeatureSetRoleItem[];
  roles?: FeatureSetRoleItem[];
}

export interface PermissionUsageResponseDto {
  featureSets?: FeatureSetRoleItem[];
  roles?: FeatureSetRoleItem[];
}

export class PermissionManagerService {
  /**
   * @returns FeatureSetRolesListDto OK
   * @throws ApiError
   */
  public static getApiCustomerApiPermissionManagerFeaturesetRolesList(): CancelablePromise<FeatureSetRolesListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/customer/api/permission-manager/featureset-roles-list',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiCustomerApiPermissionManagerUpsertPermission(
    requestBody?: UpsertPermissionDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/customer/api/permission-manager/upsert-permission',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param types Query parameter - array of permission types (e.g. ["Feature Set"])
   * @param requestBody Array of permission strings
   * @returns PermissionUsageResponseDto OK
   * @throws ApiError
   */
  public static postApiCustomerApiPermissionManagerUsage(
    types?: string[],
    requestBody?: string[]
  ): CancelablePromise<PermissionUsageResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/customer/api/permission-manager/usage',
      query: {
        types: types,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
